import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=521e356c&scoped=true&"
import script from "./SupplierInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInfo.vue?vue&type=style&index=0&id=521e356c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e356c",
  null
  
)

component.options.__file = "SupplierInfo.vue"
export default component.exports